import {FilterEntity} from './filter-entity';

export class FindEssentialEntity {
  constructor(
    public entity?: string,
    public filters?: FilterEntity[],
    public idSite: number = 0,
    public key?: string,
    public label?: string,
    public secondLabel?: string,
    public keyAlias?: string,
    public labelAlias?: string,
  ) {}
}
